// Import the functions you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // ✅ THIS WAS MISSING
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDIgtIsx1ei3KT3e2ERVDYODArdbUM8UQg",
  authDomain: "leo-arch-backend.firebaseapp.com",
  projectId: "leo-arch-backend",
  storageBucket: "leo-arch-backend.firebasestorage.app",
  messagingSenderId: "683487390150",
  appId: "1:683487390150:web:414bad7c4b7b4e88eb2ac7",
  measurementId: "G-DCXRTHY83R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// 🔥 Initialize Firestore (THIS is what you need)
export const db = getFirestore(app);

// (optional)
const analytics = getAnalytics(app);